module.exports = __webpack_public_path__ + "img/67_2.6b93f033.jpg";